import { safeDeleteSheet } from "@/lib/office-helpers";

const Q1_ROWS = [
  ["Campus universitario", 108086, 149321, 154505, 411912],
  ["Centro de la ciudad", 87023, 166592, 210292, 463907],
  ["Campus de secundaria", 54979, 75369, 53996, 184344],
  ["Parque Industrial", 53120, 114082, 90063, 257265],
  ["Zoológico", 292765, 313594, 367217, 973576],
];

const Q2_ROWS = [
  ["Campus universitario", 11099, 16426, 73935, 27525],
  ["Centro de la ciudad", 15788, 17572, 36205, 33360],
  ["Campus de secundaria", 6587, 4157, 15930, 10744],
  ["Parque Industrial", 5915, 7608, 19512, 13523],
  ["Zoológico", 57976, 65820, 27899, 123796],
];

export async function startProject22(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Trimestre 1");
    await safeDeleteSheet(context, "Trimestre 2");
    await safeDeleteSheet(context, "Gráfico Trimestre 2");

    const q1 = context.workbook.worksheets.add("Trimestre 1");
    const q2 = context.workbook.worksheets.add("Trimestre 2");

    q1.getRange("A5:F5").merge();
    q1.getRange("A5").values = [["Parrilla sobre ruedas"]];
    q1.getRange("A5").format.font.size = 28;
    q1.getRange("A5").format.font.color = "#C04000";
    q1.getRange("A8:E8").merge();
    q1.getRange("A8").values = [["Ingresos del trimestre 1 (por ubicación)"]];
    q1.getRange("A8").format.font.bold = true;
    q1.getRange("A9:E9").values = [["Ubicación", "Enero", "Febrero", "Marzo", "Total"]];
    q1.getRange("A10:E14").values = Q1_ROWS;
    q1.getRange("A15:E15").values = [["Total", "", "", "", 2291004]];
    q1.getRange("B10:E15").numberFormat = Array(6).fill(["0.00", "0.00", "0.00", "0.00"]);
    const chart1 = q1.charts.add(
      Excel.ChartType.columnClustered,
      q1.getRange("A9:E14"),
      Excel.ChartSeriesBy.columns,
    );
    chart1.title.text = "Trimestre 1 Ingresos por ubicación";
    chart1.setPosition("H4", "N15");

    q2.getRange("A5:F5").merge();
    q2.getRange("A5").values = [["Parrilla sobre ruedas"]];
    q2.getRange("A5").format.font.size = 28;
    q2.getRange("A5").format.font.color = "#C04000";
    q2.getRange("A8:F8").merge();
    q2.getRange("A8").values = [["Ingresos del trimestre 2 (por ubicación)"]];
    q2.getRange("A8").format.font.bold = true;
    q2.getRange("A9:F9").values = [["Ubicación", "Abril", "Mayo", "Junio", "Total", "Tendencia"]];
    q2.getRange("A10:E14").values = Q2_ROWS;
    q2.getRange("B10:E14").numberFormat = Array(5).fill(["0.00", "0.00", "0.00", "0.00"]);
    const chart2 = q2.charts.add(
      Excel.ChartType.pie,
      q2.getRange("A9:E14"),
      Excel.ChartSeriesBy.columns,
    );
    // Keep only the Total series (index 3), delete Abril/Mayo/Junio
    for (let i = 2; i >= 0; i--) {
      chart2.series.getItemAt(i).delete();
    }
    chart2.title.text = "Trimestre 2 Ingresos por ubicación";
    chart2.setPosition("H3", "N14");

    q1.activate();
    q1.getRange("A1").select();
    await context.sync();
  });
}
